/* Feature explainer videos (snippet mm-explainer). Tapping a [data-mm-ex-open] button opens a full-screen vertical
   player and copies the video in from its <template>, so nothing downloads before the tap. Events: mm_explainer_open,
   mm_explainer_complete (Shopify customer events, for the dashboard). */
(function () {
  if (window.mmExplainer) return;
  window.mmExplainer = true;

  var dialog, stage, titleEl, lastFocus, current, closeLabel;

  function publish(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
  }

  function build() {
    dialog = document.createElement('div');
    dialog.className = 'mm-ex-player';
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.hidden = true;
    closeLabel = (window.mmExplainerWords && window.mmExplainerWords.close) || 'Close';
    dialog.innerHTML = '<div class="mm-ex-player__backdrop" data-mm-ex-close></div>' +
      '<div class="mm-ex-player__frame">' +
      '<p class="mm-ex-player__title" id="MmExTitle"></p>' +
      '<button type="button" class="mm-ex-player__close" data-mm-ex-close aria-label="' + closeLabel + '">' +
      '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>' +
      '<div class="mm-ex-player__stage"></div></div>';
    dialog.setAttribute('aria-labelledby', 'MmExTitle');
    document.body.appendChild(dialog);
    stage = dialog.querySelector('.mm-ex-player__stage');
    titleEl = dialog.querySelector('.mm-ex-player__title');
    // anything but the video itself closes it: the backdrop, the black bars around the video, the title row, the close button
    dialog.addEventListener('click', function (e) {
      if (e.target.closest('[data-mm-ex-close]') || !e.target.closest('video')) close();
    });
  }

  function open(key, opener) {
    var tpl = document.querySelector('template[data-mm-ex-template="' + key + '"]');
    if (!tpl) return;
    if (!dialog) build();
    lastFocus = opener || document.activeElement;
    current = key;
    stage.innerHTML = '';
    stage.appendChild(tpl.content.cloneNode(true));
    titleEl.textContent = tpl.getAttribute('data-mm-ex-title') || '';
    dialog.hidden = false;
    document.documentElement.classList.add('mm-ex-open');
    var video = stage.querySelector('video');
    if (video) {
      video.setAttribute('playsinline', '');
      video.addEventListener('ended', function () { publish('mm_explainer_complete', { key: key }); }, { once: true });
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
      video.focus({ preventScroll: true });
    } else {
      dialog.querySelector('.mm-ex-player__close').focus();
    }
    publish('mm_explainer_open', { key: key, page: location.pathname });
  }

  function close() {
    if (!dialog || dialog.hidden) return;
    var video = stage.querySelector('video');
    if (video) { try { video.pause(); } catch (e) {} }
    stage.innerHTML = '';
    dialog.hidden = true;
    document.documentElement.classList.remove('mm-ex-open');
    current = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mm-ex-open]');
    if (!btn) return;
    e.preventDefault();
    open(btn.getAttribute('data-mm-ex-open'), btn);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && current) close();
    if (e.key === 'Tab' && current && dialog) {
      var f = Array.prototype.filter.call(dialog.querySelectorAll('button, video, [tabindex]:not([tabindex="-1"])'), function (n) { return n.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
})();
